import { DiagramInfo } from './diagram-info';

export class DiagramDataModel {
    isDiagramsAdded: boolean = false;
    isEditable: boolean = false;
    boltSettingsName: string;
    torqueSequenceName: string;

    flange: DiagramInfo;
    flangeFacing: DiagramInfo;
    gasket: DiagramInfo;
    tool: DiagramInfo;
    toolImage: DiagramInfo;
    engineeredJoint: DiagramInfo;
    clamp: DiagramInfo;
}
